export default __webpack_public_path__ + "static/media/menu-ads2.603b7ff3.png";